module.exports = ".contact-right img {\n  height: 600px;\n  -o-object-fit: cover;\n     object-fit: cover; }\n"